// Picks the best translation entry for a given locale (case-insensitive exact match, then language-prefix fallback).
export function findTranslation(translations, locale) {
    if (!translations || translations.length === 0)
        return undefined;
    const localeLower = locale.toLowerCase();
    const exact = translations.find(t => t.language.toLowerCase() === localeLower);
    if (exact)
        return exact;
    const prefix = localeLower.split('-')[0];
    const byPrefix = translations.find(t => t.language.toLowerCase() === prefix);
    return byPrefix;
}
